<template>
  <div>
    <template>
      <div class="add-field" v-if="!isDetails">
        <div class="code-input">
          <input
            type="number"
            v-model="generateCount"
            placeholder="Enter number of codes"
            min="1"
          />
          <button
            :class="{ disabled: !generateCount }"
            class="button-gemnote button-gemnote--small custom-button"
            @click="handleGenerateCodes"
          >
            <!-- @click.prevent="$store.dispatch('modal/setAccessCodeModal', true)" -->
            <span>Generate</span>
          </button>
        </div>
      </div>
      <!-- <div class="add-field">
        <button
          class="text-left view-generated-codes--btn"
          @click="$store.dispatch('modal/setAccessCodeModal', true)"
        >
          View generated codes (120)
        </button>
      </div> -->

      <div class="access-codes" v-if="resultQuery.length">
        <div class="access-code-header">
          <h4>Preview</h4>
          <small>{{ generateCount }} total codes generated</small>
        </div>
        <section class="access-codes-table">
          <!-- Table Region -->
          <section class="mt-3 mx-5" v-show="resultQuery.length">
            <vue-good-table
              :columns="columns"
              :rows="resultQuery"
              styleClass="vgt-table access-codes-table"
            >
              <template slot="table-row" slot-scope="list">
                <template v-if="list.column.field === 'accessCode'">
                  <span
                    class="flex gap-3 items-center"
                    @click="copyCode(list.row.accessCode)"
                  >
                    <span>{{ list.row.accessCode }}</span>
                  </span>
                </template>
                <template v-else-if="list.column.field === 'status'">
                  <span class="flex gap-1.5 items-center">
                    <span
                      class="w-2 h-2 rounded-full dot"
                      :class="
                        list.row.status === 'Unredeemed' ? 'inactive' : 'active'
                      "
                    ></span>
                    <span>{{ list.row.status }}</span>
                  </span>
                </template>
                <template v-else-if="list.column.field === 'date'">
                  <span class="flex gap-3 items-center">
                    <span>{{ list.row.date || 'D' }}</span>
                  </span>
                </template>
              </template>

              <div slot="emptystate"></div>
            </vue-good-table>
          </section>
        </section>
        <section class="access-codes-info">
          <p v-if="!isDetails">
            Note: You can view, download and manage all codes after completing
            the required steps to create your redemption page under
            <span class="sso-status-info">
              <strong>
                <button @click="handleViewSettings">
                  Redemption Page>Settings>Profile>Advanced Settings.
                </button>
              </strong></span
            >
          </p>
          <div v-else>
            <section
              class="flex md:w-1/3 gap-4 justify-start access-codes-actions flex-wrap md:flex-nowrap"
            >
              <button
                class="button-gemnote button-gemnote--small custom-button w-full"
                @click.prevent="
                  $store.dispatch('modal/setAccessCodeModal', true)
                "
              >
                <span>Manage Codes</span>
              </button>
              <button
                @click="onCloseModal"
                class="button-gemnote button-gemnote--small  w-full"
              >
                <span>DOWNLOAD CSV</span>
              </button>
            </section>
          </div>
          <!-- Tip Section -->
          <section class="tip-section">
            <div class="flex items-start gap-2 tip-section__header">
              <img src="../../../assets/warning.svg" class="w-5" />
              <p>
                <strong
                  >Individual Access Codes need to be downloaded for sharing and
                  personal distribution. Gemnote is not responsible for sending
                  the codes to recipients.</strong
                >
              </p>
            </div>
          </section>
        </section>
      </div>
    </template>

    <template>
      <Modal
        v-if="modalActive"
        modalName="AccessCodeModal"
        :showFooter="false"
        :isAllowList="false"
        :isAccessCode="true"
        @hideModal="onCloseModal"
        colorVariation="primary"
        modalHeaderStyles="text-align: center; padding-top: 1rem"
        width="900px"
      >
        <template slot="header">
          Individual Access Codes
        </template>
        <template slot="body">
          <!-- Top header region -->
          <p
            class="text-sm modal-header-info text-center font-[400] margin-top-2"
          >
            View, manage and download codes for sharing.
          </p>
          <section
            class="generate-code-header flex flex-col md:flex-row gap-4 items-center justify-between"
          >
            <div
              class="flex flex-col md:flex-row items-center justify-start gap-4 mt-3 md:mt-0 w-full md:w-4/5"
            >
              <p class="label-text font-[500] mr-1 text-left">
                Number of codes
              </p>

              <div class="w-full  md:w-max mx-4 relative">
                <input
                  type="number"
                  id="generate-number"
                  placeholder="Enter number"
                  class="text-sm"
                  v-model="noOfCodesToGenerate"
                />
              </div>
              <div class="w-max" v-if="resultQuery.length">
                <button
                  class="button-gemnote button-gemnote--small custom-button w-max"
                  :class="{ isDisabled: noOfCodesToGenerate <= 0 }"
                  @click="onGenerateCode"
                >
                  <span>Generate</span>
                </button>
              </div>
            </div>
            <div class="w-max" v-if="resultQuery.length">
              <button
                class="button-gemnote button-gemnote--small download-button w-max"
                :class="{ isDisabled: noOfCodesToGenerate <= 0 }"
                @click="onGenerateCode"
              >
                <span>Download CSV</span>
                <img src="@/assets/download.svg" alt="" />
              </button>
            </div>
          </section>
          <section
            class="filter-header flex items-center justify-between"
            v-if="resultQuery.length"
          >
            <div
              class="flex items-center justify-start gap-4 mt-3 md:mt-0 w-max"
            >
              <div class="access-code-header">
                <h4>{{ generateCount }}</h4>
                <small>codes generated</small>
              </div>
            </div>
            <div class="w-max">
              <div class="filters">
                <!-- <div class="flex items-center">
                  <img
                    src="@/assets/filter-icon.svg"
                    alt=""
                    class="cursor-pointer"
                  />

                  <div class="dateFilter">
                    <v-select
                      class="access-code"
                      :options="filterOptions"
                      maxHeight="200px"
                      :clearable="false"
                      :searchable="false"
                      v-model="currentFilter"
                      @input="onFilterChange"
                      :placeholder="''"
                    >
                      <template #option="{ label, text }">
                        <div class="flex" style="gap: 1.6rem">
                          <label class="checkbox-container">
                            <input
                              type="checkbox"
                              :checked="currentFilter.text == text"
                            />
                            <span class="checkmark top"></span>
                          </label>
                          <span
                            style="position: relative; top: 0.2rem; font-size: 13px"
                            >{{ label }}</span
                          >
                        </div>
                      </template>
                      <template #open-indicator="{ attributes }">
                        <span
                          v-bind="attributes"
                          style="position: relative; left: -28px"
                        >
                          <svg
                            width="9"
                            height="5"
                            viewBox="0 0 9 5"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M4.5 5C4.38766 5 4.27531 4.95646 4.18974 4.86983L0.128691 0.758491C-0.0428968 0.584779 -0.0428968 0.303996 0.128691 0.130284C0.300278 -0.043428 0.577626 -0.043428 0.749214 0.130284L4.5 3.92752L8.25079 0.130284C8.42237 -0.043428 8.69972 -0.043428 8.87131 0.130284C9.0429 0.303996 9.0429 0.584779 8.87131 0.758491L4.81026 4.86983C4.72469 4.95646 4.61234 5 4.5 5Z"
                              fill="#25282A"
                            />
                          </svg>
                        </span>
                      </template>
                    </v-select>
                  </div>
                </div> -->
                <button
                  class="delete flex items-center"
                  :class="{ isDisabled: !selectedAccessCodes.length }"
                >
                  <img src="@/assets/copy.svg" alt="" />
                </button>
                <button
                  class="delete flex items-center"
                  :class="{ isDisabled: !selectedAccessCodes.length }"
                  @click="handleDeleteSeectedAccessCodes"
                >
                  <img src="@/assets/trash.svg" alt="" />
                </button>
              </div>
            </div>
          </section>

          <div class="access-codes-table-holder">
            <section class="access-codes-table">
              <!-- Table Region -->
              <section class="mt-3 mx-5" v-show="resultQuery.length">
                <vue-good-table
                  :columns="tablecolumns"
                  :rows="resultQuery"
                  styleClass="vgt-table access-codes-modal-table"
                >
                  <template slot="table-column" slot-scope="list">
                    <span
                      v-if="list.column.field == 'select'"
                      style="display: block; justify-content: center;"
                    >
                      <label class="checkbox-container">
                        <input
                          type="checkbox"
                          :checked="selectAllUnredeemed"
                          @click.stop="handleSelectAllAccessCodes"
                        />
                        <span class="checkmark checkmark-center"></span>
                      </label>
                      <span style="padding-left: 1.4rem;">
                        {{ list.column.label }}</span
                      >
                      Select All
                    </span>
                  </template>

                  <template slot="table-row" slot-scope="list">
                    <template v-if="list.column.field === 'select'">
                      <div
                        class="form-control icon-control"
                        style="width: max-content; margin: 0px auto; position: relative; left: -15px;"
                      >
                        <label class="checkbox-container">
                          <input
                            :disabled="list.row.status === 'Unredeemed'"
                            type="checkbox"
                            :checked="selectedAccessCodes.includes(list.row.id)"
                            @click.stop="handleAccessCodeSelection(list.row.id)"
                          />
                          <span class="checkmark checkmark-center"></span>
                        </label>
                      </div>
                    </template>
                    <template v-else-if="list.column.field === 'accessCode'">
                      <span
                        class="flex gap-3 items-center"
                        @click="copyCode(list.row.accessCode)"
                      >
                        <span>{{ list.row.accessCode }}</span>
                        <!-- <img
                          src="../../../assets/copy-icon.svg"
                          class="copy-icon"
                          alt=""
                        /> -->
                      </span>
                    </template>
                    <template v-else-if="list.column.field === 'status'">
                      <span class="flex gap-1.5 items-center">
                        <span
                          class="rounded-full dot"
                          :class="
                            list.row.status === 'Unredeemed'
                              ? 'inactive'
                              : 'active'
                          "
                        ></span>
                        <span>{{ list.row.status }}</span>
                      </span>
                    </template>
                    <template v-else-if="list.column.field === 'date'">
                      <span class="flex gap-3 items-center">
                        <span>{{ list.row.date || 'D' }}</span>
                      </span>
                    </template>
                  </template>

                  <div slot="emptystate"></div>
                </vue-good-table>
              </section>
            </section>
            <!-- Footer Region -->
            <section class="mt-3 mx-5" v-if="resultQuery.length">
              <Pagination
                :total-items="80"
                :max-visible-pages="3"
                :page="0"
                :showResultsCount="false"
                :showPerPageDropdown="false"
                :items-per-page="5"
                @page-change="() => null"
                @perPageChange="() => null"
                paginationContainerStyle="margin-top:0.4rem;align-items:center"
                paginationMainStyle="align-items:center;justify-content:center"
              />
            </section>
            <section class="mt-3 mx-5" v-else>
              <section
                class="flex md:w-1/3 gap-4 justify-end footer-codes-actions margin-top-4"
              >
                <button
                  @click="onGenerateCode"
                  :class="{ isDisabled: noOfCodesToGenerate <= 0 }"
                  class="whitebutton-gemnote full-btn whitebutton-gemnote--small"
                >
                  <span>Generate</span>
                </button>
              </section>
            </section>
          </div>
        </template>
      </Modal>
    </template>
  </div>
</template>

<script>
import Modal from '@/components/Universal/RemoveModal.vue'
import { VueGoodTable } from 'vue-good-table'
const dummyAccessCodes = [
  {
    date: '',
    accessCode: 'ABC75H',
    redemptionate: '12/03',
    status: 'Unredeemed',
    id: 1
  },
  {
    date: '12/03',
    accessCode: 'ABC75H',
    redemptionate: '12/03',
    status: 'Redeemed',
    id: 2
  },
  {
    date: '12/03',
    accessCode: 'ABC75H',
    redemptionate: '--/--',
    status: 'Unredeemed',
    id: 3
  },
  {
    date: '12/03',
    accessCode: 'ABC75H',
    redemptionate: '12/03',
    status: 'Redeemed',
    id: 4
  },
  {
    date: '12/03',
    accessCode: 'ABC75H',
    redemptionate: '12/03',
    status: 'Redeemed',
    id: 5
  }
]
export default {
  name: 'AccessCodesModal',
  props: ['modalActive'],
  data() {
    return {
      filterOptions: [
        {
          label: 'Redeemed codes',
          text: 'Redeemed'
        },
        {
          label: 'Unredeemed Codes',
          text: 'Unredeemed'
        }
      ],
      selectAllUnredeemed: false,
      noOfCodesToGenerate: null,
      columns: [
        {
          label: 'Date Created',
          field: 'date',
          width: '90px',
          sortable: true
        },
        {
          label: 'Individual Access Code',
          width: '180px',
          field: 'accessCode'
        },
        {
          label: 'Redemption Date',
          field: 'redemptionate',
          width: '80px'
        },
        {
          label: 'Status',
          field: 'status',
          width: '120px'
        }
      ],
      tablecolumns: [
        {
          label: '',
          field: 'select',
          width: '120px',
          sortable: false
        },
        {
          label: 'Date Created',
          field: 'date',
          width: '120px',
          sortable: true
        },
        {
          label: 'Individual Access Code',
          width: '180px',
          field: 'accessCode'
        },
        {
          label: 'Redemption Date',
          field: 'redemptionate',
          width: '140px'
        },
        {
          label: 'Status',
          field: 'status',
          width: '120px'
        }
      ],
      currentFilter: '',
      resultQuery: [],
      selectedAccessCodes: [],
      generateCount: ''
    }
  },

  created() {
    if (this.$route.fullPath.split('/').includes('details')) {
      this.generateCount = 20
      this.resultQuery = dummyAccessCodes
    }
  },

  components: {
    Modal,
    Pagination: () => import('@/components/Universal/Pagination'),
    VueGoodTable
  },
  methods: {
    validateEmail(value) {
      // eslint-disable-next-line no-useless-escape
      return /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
        value
      )
    },
    handleSelectAllAccessCodes() {
      if (this.selectedAccessCodes.length === this.resultQuery.length) {
        this.selectedAccessCodes = []
        this.selectAllUnredeemed = false
      } else {
        this.resultQuery.forEach(code => {
          this.selectedAccessCodes.push(code.id)
        })
        this.selectAllUnredeemed = true
      }
    },
    handleAccessCodeSelection(id) {
      const isSelected = this.selectedAccessCodes.includes(id)
      if (isSelected) {
        this.selectedAccessCodes = this.selectedAccessCodes.filter(
          accessCode => accessCode !== id
        )
      } else {
        this.selectedAccessCodes.push(id)
      }
    },
    handleDeleteSeectedAccessCodes() {
      this.resultQuery = dummyAccessCodes.filter(
        accessCode => !this.selectedAccessCodes.includes(accessCode.id)
      )
    },

    onGenerateCode() {
      this.resultQuery = dummyAccessCodes
    },
    onCloseModal() {
      this.$store.dispatch('modal/setAccessCodeModal', false)
      if (this.resultQuery.length) {
        this.$emit('accessCodeGenerated', true)
      }
      // this.resultQuery = []
      // this.noOfCodesToGenerate = 0
    },

    onFilterChange(filter) {
      console.log(filter)
      this.currentFilter = filter
      this.resultQuery = dummyAccessCodes.filter(
        query => query.status === filter.text
      )
    },
    handleGenerateCodes() {
      if (this.generateCount) {
        this.resultQuery = dummyAccessCodes
        this.$emit('accessCodeGenerated', true)
      } else {
        this.$store.dispatch('notification/pushNotification', {
          type: 'error',
          messages: [`Number of codes to generate is required.`]
        })
      }
    },
    handleViewSettings() {
      window.open('/profile/advanced', '_blank')
    },

    copyCode(code) {
      this.$copyText(code).then(
        () => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'success',
            messages: [`Access  Code copied`]
          })
        },
        error => {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [`Unable to copy Access Code.`]
          })
          console.log(error)
        }
      )
    }
  },
  computed: {
    isDetails() {
      return this.$route.fullPath.split('/').includes('details')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.generate-code-header {
  width: 90%;
  margin: 3.5rem auto auto auto;
  // padding-bottom: 1.5rem;

  p {
    font-size: 0.813rem;
    font-weight: 500;
  }

  input {
    height: 100%;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &::placeholder {
      color: #a09c95;
      font-weight: 300;
    }
  }
  .button-gemnote--small {
    height: 2rem;
    text-transform: unset;
    padding: 0px 1.5rem !important;
    font-weight: normal;
    width: auto;
    border-color: #232220;

    &.custom-button {
      background-color: #232220;
      color: #f5f2ee;
      text-transform: uppercase;
      &.isDisabled {
        opacity: 0.8;
        cursor: not-allowed;
      }
    }
    &.download-button {
      background-color: transparent;
      text-decoration: underline;
      font-size: 0.813rem;
      border: none;
      color: #24292c;
      gap: 4px;
      font-weight: 700;
      padding: 0 !important;
    }
  }
}

.filter-header {
  width: 90%;
  margin: 0px auto;
  padding: 1.2rem 0;
  padding-bottom: 0px;

  .info {
    font-size: 1rem;
    color: #232220;
  }

  .filters {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;

    span.small {
      font-size: 0.89rem;
    }

    .dateFilter {
      position: absolute;
      width: 0px;
      min-width: 0px;
      display: flex;
      gap: 0.4rem;
      align-items: center;
      padding-left: 6px;
      cursor: pointer;

      .v-select {
        width: 100%;
      }
      .light {
        border: none !important;
      }
      .button-gemnote--small {
        background: transparent;
      }
    }

    .filter-tag {
      min-width: 0px;
      position: relative;
      cursor: pointer;
      font-family: 'Nunito Sans';
      background-color: #dfdad2;
      font-size: 0.665rem;
      color: #24292c;
      margin: 0 6px;
      padding: 4px 14px;
      border-radius: 20px;
      font-weight: 600;
      font-size: 0.775rem;

      .remove {
        cursor: pointer;
        padding-left: 8pt;
        text-decoration: none;
        font-size: 0.675rem;
      }
    }

    .clear-filter-tag {
      font-weight: 700;
      font-size: 0.925rem;
      text-decoration: underline;
    }
    .delete {
      cursor: pointer;
      gap: 0.5rem;

      &.isDisabled {
        opacity: 0.8;
        cursor: not-allowed;
      }

      img {
        width: 17px;
      }
      span {
        font-size: 0.813rem;
      }
    }
  }
}

.access-code-header {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin-bottom: 1rem;

  h4 {
    font-size: 0.853rem;
    font-weight: 700;
  }
  small {
    color: #514d43;
    font-size: 0.713rem;
  }
}

.access-codes {
  margin-top: 2rem;

  .access-code-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;

    h4 {
      font-size: 0.953rem;
      font-weight: 700;
    }
    small {
      color: #514d43;
    }
  }

  .access-codes-table {
    width: 80%;
  }
  .access-codes-info {
    margin-top: 1.5rem;
    width: 95%;

    p {
      color: #232220;
      font-size: 0.813rem;
      font-style: italic;
      font-weight: 400;
      text-align: left;
      button {
        font-weight: 700;
        font-style: italic;
      }
    }
    .tip-section {
      width: 100%;
      margin-top: 1.5rem;
      background-color: #fba04c33;
      padding: 1.5rem;
      border-radius: 12px;
      margin-bottom: 1.5rem;

      .tip-section__header {
        img {
          width: 20px;
          position: relative;
          top: -2px;
          right: -2px;
        }

        p {
          text-align: left;
          font-size: 0.783rem;
          color: #514d43;
          font-style: normal;
          strong {
            color: #232220;
          }
        }
      }
    }
  }
}

.modal-header-info {
  font-weight: 400;
  font-size: 0.873rem;
}
.access-codes-table-holder {
  width: 90%;
  margin: 0px auto;
  max-height: 500px;
  height: 500px;
  overflow-y: auto;
  .access-codes-table {
    min-height: 300px;
    width: 95%;
    margin-left: auto;
  }
}

@media (min-width: 768px) {
  .access-codes-table {
    min-height: 300px;
  }
}
@media (max-width: 768px) {
  .access-codes-table-holder {
    padding-bottom: 8rem;
  }
}

.access-codes-actions {
  margin-bottom: 0.5rem;
  margin-right: auto;
  .button-gemnote--small {
    height: 2rem;
    text-transform: uppercase;
    padding: 0px 1rem !important;
    font-weight: normal;
    width: auto;
    border-color: #232220;

    &.custom-button {
      background: #dfdad2;
      color: #232220;
      text-transform: uppercase;
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.isDisabled {
      opacity: 0.8;
      cursor: not-allowed;
    }
  }
  .whitebutton-gemnote--small {
    text-transform: uppercase;
    padding: 0px 2rem !important;
    width: auto;
    border-color: #232220;
    background-color: #232220;
    color: #fff;

    &.custom-button {
      background: inherit;
      text-transform: uppercase;
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.isDisabled {
      opacity: 0.8;
      cursor: not-allowed;
    }
  }
}
.footer-codes-actions {
  margin-bottom: 0.5rem;
  margin-left: auto;
  .button-gemnote--small {
    height: 2.575rem;
    text-transform: uppercase;
    padding: 0px 2rem !important;
    font-weight: normal;
    width: auto;
    border-color: #232220;

    &.custom-button {
      background: inherit;
      color: #232220;
      text-transform: uppercase;
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.isDisabled {
      opacity: 0.8;
      cursor: not-allowed;
    }
  }
  .whitebutton-gemnote--small {
    text-transform: uppercase;
    padding: 0px 2rem !important;
    width: auto;
    border-color: #232220;
    background-color: #232220;
    color: #fff;

    &.custom-button {
      background: inherit;
      text-transform: uppercase;
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.isDisabled {
      opacity: 0.8;
      cursor: not-allowed;
    }
  }
}

.copy-icon {
  width: 10px;
  height: 100%;
  cursor: pointer;
}

.dot {
  display: block;
  background-color: #68c67e !important;
  &.active {
    background-color: #a5b7c1 !important;
  }
}

.add-field {
  text-align: left;
  margin-top: 1rem;
  .button-gemnote--small {
    height: 2.375rem;
    text-transform: unset;
    padding: 0px 2rem !important;
    font-weight: normal;
    width: auto;

    &.custom-button {
      background: inherit;
      color: $onyx;
      text-transform: uppercase;
    }
  }

  .code-input {
    margin-top: 1.5rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    input {
      width: 240px;
      height: 100%;
    }
    .custom-button {
      background: inherit;
      color: $onyx;
      text-transform: uppercase;
      background-color: #dfdad2;
    }
  }

  .view-generated-codes--btn {
    font-size: 0.853rem;
    font-weight: 500;
    text-decoration: underline;
  }
}
</style>
